import React from 'react';

import { CodingVerdictResult } from './coding-problem__verdict-result';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './coding-problem__verdict.module.scss';

export const CodingVerdict = () => (
    <div className={styles.wrapper}>
        <CodingVerdictResult />
    </div>
);
